<template>
  <Suspense>
    <template #default>
      <div class="listings" id="listings" ref="listings">
        <div class="listings__container" :class="{ 'is--loading': loadingResources }">
          <div 
            class="listings__card" 
            v-for="(item, index) in wpAPI" 
            :key="item.id"
            :class="{ 'large': shouldHaveLargeClass(index), 'regular': !shouldHaveLargeClass(index) }"
          >
            <a :href="item.permalink" class="listings__link">
              <div 
                class="listings__image-container" 
              >
                <img v-if="item.acf_thumb_image_l_url" :src="item.acf_thumb_image_l_url" alt="item.acf_thumb_image_l_alt" class="listings__image" >
                <img v-else-if="item.acf_thumb_image_url" :src="item.acf_thumb_image_url" alt="item.acf_thumb_image_alt" class="listings__image" >
                <img v-else :src="props.thumbPlaceholder" alt="" class="listings__image">
                <span class="listings__image-details">
                  <div>Author<span>{{ item.acf_author }}</span></div>
                  <div v-if="item.acf_tags && !isMobile">Tags<span>{{ item.acf_tags }}</span></div>
                  <div>Read Time<span>{{ item.acf_read_time }} minutes</span></div>
                </span>
              </div>
              <div class="listings__details">
                <div class="listings__header">
                  <span v-if="!isMobile" class="listings__date tt--u">
                    {{ formatDate(item.date) }}
                  </span>
                  <h2 class="tt--u">{{ item.title }}</h2>
                  <span class="listings__excerpt">
                    {{ item.acf_excerpt }}
                  </span>
                </div>
                <div class="listings__cta">
                  <span v-if="isMobile" class="listings__date tt--u">
                    {{ formatDate(item.date) }}
                  </span>
                  <button-read-more v-if="isMobile"></button-read-more>
                  <div v-else class="listings__cta-magnetic">
                    <magnetic-button 
                      :testing=false
                      buttonSize="90px"
                      magnetPadding="80px"
                      buttonText="Read"
                      buttonColor="black">
                    </magnetic-button>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="listings__card listings__card--last" v-if="shouldShowLastCard">
          </div>
        </div>
        <div class="listings__pagination" v-if="totalResources > props.perPage && (page + 1) * props.perPage < totalResources">
          <div class="cta__button" v-if="!loadingResources">
            <a 
            @click.prevent="nextPage"  
            class="cta__link cta__link--large plus"
            :class="{ 'is--loading': loadingResources }">
              Load <em>More</em>
              <img src="//localhost:3000/wp-content/themes/allisstudio-v2/build/images/svgs/icon-plus.svg" alt="Icon depicting a speech-bubble" class="cta__icon cta__icon--plus"></a>
          </div>
          <div v-else class="cta__button">
            <div class="cta__link cta__link--large">Loading...</div>
          </div>
            <!-- <div class="listings__results">
              {{ (page + 1) * props.perPage < totalResources ? (page + 1) * props.perPage : totalResources }} of {{ totalResources }} total posts
            </div> -->
            <!-- <a href="#listings" class="listings__button">Back to Top<svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none"> <path d="M1 7.5L6.5 2L12 7.5" stroke="#081F2C" stroke-width="1.57143"/></svg></a> -->
        </div>
      </div>
    </template>
    <template #fallback>
      Loading...
    </template>
  </Suspense>
</template>

<script setup>
  import { ref, watch, defineProps, computed } from 'vue'
  import axios from 'axios'
  import { isMobile } from 'mobile-device-detect';
  import MagneticButton from '../components/MagneticButton.vue';

  const props = defineProps({
    totalResources: Number,
    perPage: Number,
    apiUrl: String,
    thumbPlaceholder: String,
  })
  const wpAPI = ref(null)
  const page = ref(0)
  const totalPages = Math.ceil(props.totalResources / props.perPage)
  const loadingResources = ref(false)
  
  const shouldShowLastCard = computed(() => {
    if (page.value === totalPages - 1) {
      const specialValues = [2, 4, 7, 9, 12, 14, 17, 19, 22, 24, 27, 28, 31, 32, 35, 37, 40, 42, 45, 47, 50, 52]; 
      return specialValues.includes(props.totalResources);
    }
    return false;
  });

  // Fetch data when the component is mounted
  const fetchData = async () => {
    try {
      const response = await axios.get(`${props.apiUrl}per_page=${props.perPage}&offset=0`)
      wpAPI.value = response.data
    } catch (error) {
      console.error(error)
    }
  }

  const prevPage = () => {
    if (page.value > 0) {
      page.value--
      // scrollToListings()
    }
  }

  const navigate = (url) => {
    window.location.href = url
  }

  const nextPage = () => {
    if (page.value < totalPages - 1) {
      page.value++
      loadingResources.value = true
      // scrollToListings()
    }
  }

  const scrollToListings = () => {
    loadingResources.value = true
    const listingsElement = document.getElementById('listings')
    if (listingsElement) {
      listingsElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const shouldHaveLargeClass = (index) => {
    // Add 1 to index because the indices start from 0
    if(!isMobile){
      return (index + 1) % 5 === 1; // Add 'large' class to 1st, 6th, 11th, etc.
    }
    
  };

  fetchData()

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  watch(page, async () => {
    try {
      // Load More
      const response = await axios.get(`${props.apiUrl}per_page=${(page.value + 1) * props.perPage}`)
      wpAPI.value = response.data
      loadingResources.value = false
    } catch (error) {
      console.error(error)
    }
  })
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter-from, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
</style>